import request from '@/utils/request'

const licencesApi = {
  // get licences info
  licences: '/api/v1/rest/licences',
  findByKeyword: '/api/v1/rest/licences/search/findByKeyword',
  findByHouses_Id: '/api/v1/rest/licences/search/findByHouseId'
}

export function licences (parameter) {
  return request({
    url: licencesApi.licences + `?page=${parameter.page}&size=${parameter.size}&sort=${parameter.sort}`,
    method: 'get'
  })
}

export function addLicences (parameter) {
  return request({
    url: licencesApi.licences,
    method: 'post',
    data: parameter
  })
}

export function editLicences (parameter) {
  return request({
    url: licencesApi.licences + `/${parameter.id}`,
    method: 'patch',
    data: parameter
  })
}

export function delLicences (parameter) {
  return request({
    url: licencesApi.licences + `/${parameter.id}`,
    method: 'delete'
  })
}

export function putLicencesMedia (licencesId, data) {
  return request({
    url: licencesApi.licences + '/' + licencesId + '/img',
    method: 'put',
    headers: {
      'Content-Type': 'text/uri-list'
    },
    data
  })
}

export function findLicences (parameter) {
  return request({
    url: licencesApi.findByKeyword + `?keyword=${parameter.keyword}&page=${parameter.page}&size=${parameter.size}&sort=${parameter.sort}`,
    method: 'get'
  })
}

export function findByIdLicences (parameter) {
  return request({
    url: licencesApi.licences + `/${parameter.id}`,
    method: 'get'
  })
}

export function inLicences (parameter) {
  return request({
    url: licencesApi.licences + `/${parameter.id}/${parameter.name}`,
    method: 'get'
  })
}

export function addInLicences (parameter) {
  return request({
    url: licencesApi.licences + `/${parameter.id}/${parameter.name}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function findByHousesIdLicences (parameter) {
  return request({
    url: licencesApi.findByHouses_Id + `?houseId=${parameter.id}&page=${parameter.page}&size=${parameter.size}&sort=${parameter.sort}`,
    method: 'get'
  })
}
